module.exports = __webpack_public_path__ + "static/media/radar-chart.0c90a502.png";